import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const fieldsToTrackAdapter = getAdapter({ idFieldName: 'id' });

const fieldsToTrackSlice = createSlice({
  name: 'fieldsToTrack',
  initialState: fieldsToTrackAdapter.getInitialState(),
  reducers: {
    setFieldsToTrack: (state, { payload: { fieldsToTrack } }) => {
      fieldsToTrackAdapter.setAll(state, fieldsToTrack);
    }
  }
});

const selectors = fieldsToTrackAdapter.getSelectors(({ fieldsToTrack }) => fieldsToTrack);

export const getFieldsToTrack = state => selectors.selectAll(state);

export const { setFieldsToTrack } = fieldsToTrackSlice.actions;

export default fieldsToTrackSlice.reducer;
